// extracted by mini-css-extract-plugin
var _1 = "BcRPD";
var _2 = "qdJuq";
export { _1 as "base", _2 as "name" }
